<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Số điện thoại" v-model="phone" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Họ tên" v-model="buyerName" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Email" v-model="email" clearable flat outlined dense hide-details />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="primary" height="40px" width="100%" outlined @click="onFilterChanged">
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Phân khúc"
              v-model="segment"
              :items="segmentOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Hệ đào tạo quan tâm"
              v-model="product"
              :items="formattedProducts"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              v-model="interest"
              placeholder="Mức độ quan tâm"
              :items="interestOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex justify-space-between " cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-if="advancedFilter"
              v-model="studentNameSearchField"
              placeholder="Tên học sinh"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-if="advancedFilter"
              v-model="studentSchoolSearchField"
              placeholder="Trường"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-if="advancedFilter"
              placeholder="Nguồn marketing"
              v-model="importOrigin"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="primary" height="40px" width="100%" @click="advancedFilter = !advancedFilter" text>
          Nâng cao <v-icon v-if="!advancedFilter">mdi-chevron-down</v-icon
          ><v-icon v-if="advancedFilter">mdi-chevron-up</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Năm học"
              :items="schoolYears"
              v-model="selectedSchoolYear"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import utils from '@/plugins/utils'
export default {
  computed: {
    formattedProducts() {
      return this.products.map(p => ({title: p.name, value: p.id}))
    }
  },
  props: {
    products: Array
  },
  data() {
    return {
      advancedFilter: false,
      show: false,
      phone: '',
      buyerName: '',
      email: '',
      studentNameSearchField: '',
      studentSchoolSearchField: '',
      type: '',
      product: [],
      importOrigin: '',
      selectedSchoolYear: '2023-2024',
      segment: {},
      interest: {},
      segmentOptions: [
        {title: 'Phổ thông', value: 'intermediate'},
        {title: 'Cao cấp', value: 'advance'}
      ],
      interestOptions: [
        {title: 'Thấp', value: 'cold'},
        {title: 'Vừa', value: 'warm'},
        {title: 'Cao', value: 'hot'}
      ],
      schoolYears: [{title: 'Năm học 2023-2024', value: '2023-2024'}]
    }
  },
  methods: {
    onFilterChanged() {
      let query = {
        phone_contains: this.phone,
        buyerName_contains: this.buyerName,
        email_contains: this.email,
        products: this.product,
        studentNameSearchField_contains: utils.removeUnicode(this.studentNameSearchField),
        studentSchoolSearchField_contains: utils.removeUnicode(this.studentSchoolSearchField),
        importOrigin_contains: this.importOrigin,
        interest: this.interest,
        segment: this.segment
      }
      this.$emit('onFilterChanged', query)
    }
  }
}
</script>
